import {useEffect,useState} from 'react';
import {useDocumentIntakeContext} from '../document-intake-context';

type Hold={wouldFile:boolean;reasons:string[]};
/** Priority 3 (20 Oct 2026): why automatic filing held this document, so the reviewer knows what to check before confirming. */
export function DocumentHoldReasons({itemId}:{itemId:string}){
 const {api,building}=useDocumentIntakeContext();
 const [hold,setHold]=useState<Hold|null>();
 useEffect(()=>{let active=true;setHold(undefined);
  void api<Hold>(`/api/documents/filing-readiness/items/${itemId}`).then(result=>{if(active)setHold(result)}).catch(()=>{if(active)setHold(null)});
  return()=>{active=false;};
 },[itemId,building]);
 if(!hold)return null;
 if(hold.wouldFile)return <p className="document-hold-reasons">Automatic filing checks now find nothing holding this document back. Confirm it to file it.</p>;
 if(!hold.reasons.length)return null;
 return <section className="document-hold-reasons" aria-label="Why this document is waiting"><h3>Why this is waiting for you</h3>
  <ul>{hold.reasons.map(reason=><li key={reason}>{reason}</li>)}</ul>
 </section>;
}
